import React, { useState } from 'react';
import "./Search.scss";

const Search = ({ width }) => {

    const [search] = useState("")
    const [subjectSearch] = useState("");
    const [categoryArray] = useState([]);
    const [zonesArray] = useState([]);
    const changeHandler = () => {
        console.log("Hola")
    }


    return (
        <div className="search">
            <input
                className="search-input"
                placeholder="Buscar un prestador"
                autoFocus="on"
                style={{ width: `${width}` }}

            />

            <button
                onClick={search}
                className="button-search"
                variant="outline-secondary"
            >
                <i className="fas fa-search" />
                {" Buscar"}
            </button>
        </div>
    )
};

export default Search;